import * as types from '../actions/actionTypes';

const defaultState = {
  loading: false,
  loadingCodes: false,
  codes: {
    data: [],
    total: 0,
    page: 1,
  },
  editting: false,
  updating: false,
  references: {},
  positionList: [],
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case types.FETCH_USER_SUCCESS:
      if (!action.payload) {
        console.log("User doesn't exist in User Profile");
      }
      return { ...state, ...action.payload, loading: false };
    case types.UPDATE_KAT_ADDRESS_SUCCESS:
      return { ...state, ...action.payload, loading: false };
    case types.FETCH_CODES_OF_USER_SUCCESS:
      const { data, total, page } = action.payload;
      return {
        ...state,
        codes: { data: [...state.codes.data, ...data], total, page },
        loadingCodes: false,
      };
    case types.FETCH_USER:
      return { ...state, loading: true };
    case types.FETCH_USER_FAILED:
      return { ...state, loading: false };
    case types.FETCH_CODES_OF_USER:
      return { ...state, loadingCodes: true };
    case types.SET_EDITTING:
      return { ...state, editting: action.payload };
    case types.UPDATE_USER:
      return { ...state, updating: true };
    case types.UPDATE_USER_FAILED:
      return { ...state, updating: false };
    case types.UPDATE_USER_SUCCESS:
      return { ...state, updating: false, ...action.payload };
    case types.UPDATE_PROFILE_PICTURE:
      return { ...state, updatingProfilePicture: true };
    case types.UPDATE_PROFILE_PICTURE_FAILED:
      return { ...state, updatingProfilePicture: false };
    case types.UPDATE_PROFILE_PICTURE_SUCCESS:
      return {
        ...state,
        updatingProfilePicture: false,
        avatarUrl: action.avatarUrl,
      };
    case types.UPDATE_REFERENCE:
      return {
        ...state,
        references: { ...state.references, ...action.payload },
      };
    case types.FETCH_ALL_POSITION_SUCCESS:
      return { ...state, positionList: action.payload };

    default:
      return state;
  }
};
